/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export const EXPAND_RECORD_OPERATE_BUTTON = 'EXPAND_RECORD_OPERATE_BUTTON';
export const EXPAND_RECORD_COMMENT_WRAPPER = 'EXPAND_RECORD_COMMENT_WRAPPER';
export const COMMENT_SUBMIT_BUTTON = 'COMMENT_SUBMIT_BUTTON';
export const EXPAND_RECORD_ACTIVITY_ITEM = 'EXPAND_RECORD_ACTIVITY_ITEM';
export const EXPAND_RECORD_DELETE_COMMENT_MORE = 'EXPAND_RECORD_DELETE_COMMENT_MORE';
export const NOTIFICATION_ITEM_RECORD = 'NOTIFICATION_ITEM_RECORD';
export const MODAL_FOOTER_BTN_CONFIRM = 'MODAL_FOOTER_BTN_CONFIRM';
